























import { Vue, Component, Prop } from 'vue-property-decorator';
import type { Dictionary } from 'vue-router/types/router';

@Component({
  name: 'BaseDropdownItem',
})
export default class BaseDropdownItem extends Vue {
  @Prop() to: {
    path: string;
    name: string;
    params?: Dictionary<string>;
    query?: Record<string, string>;
  };
  @Prop() disabled?: boolean;
  @Prop({ default: false }) active: boolean;
  @Prop() dataExternal?: string;

  handleClick(event: Event) {
    if (this.disabled) {
      return;
    }
    this.$emit('click', event);
  }

  get componentTag(): string {
    return this.to ? 'router-link' : 'button';
  }
}
